import { datadogRum } from "./datadog";
import { emitProductAnalyticsEvent } from "./otel";

/**
 * Pairs a Stitch analytics event name with a typed properties interface and
 * fans out to Datadog RUM and the OpenTelemetry collector (→ Snowflake).
 *
 * Both emits are no-ops when their respective SDK did not initialize (tests,
 * automation, MSW mocking, missing tokens, or SSR), so call sites don't need
 * to guard themselves.
 */
export type EventDefinition<TProps extends Record<string, unknown> | void> = {
  readonly name: string;
  readonly track: [TProps] extends [void]
    ? () => void
    : (properties: TProps) => void;
};

export function defineEvent<
  TProps extends Record<string, unknown> | void = void,
>(name: string): EventDefinition<TProps> {
  const track = (properties?: TProps) => {
    const props = properties as Record<string, unknown> | undefined;
    datadogRum.addAction(name, props);
    emitProductAnalyticsEvent(name, props);
  };
  return {
    name,
    track: track as EventDefinition<TProps>["track"],
  };
}
